<template>
  <!-- data -->
  <div class="data-table">
    <portal :to="'modal-taiosu-' + chatbot.bot_id">
      <template v-if="!isLoading">
        <span style="font-size: 20px; font-weight: 700; color: #2c3e50;">{{taiosu}}</span>
      </template>
      <template v-else>
        <span class="mdi mdi-loading mdi-spin" style="font-size: 20px; color: #2c3e50;"></span>
      </template>
    </portal>
    <portal :to="'modal-kanryosu-' + chatbot.bot_id">
      <template v-if="!isLoading">
        <span style="font-size: 20px; font-weight: 700; color: #27ae60;">{{kanryosu}}</span>
      </template>
      <template v-else>
        <span class="mdi mdi-loading mdi-spin" style="font-size: 20px; color: #27ae60;"></span>
      </template>
    </portal>
    <p v-if="!isLoading">{{botAction(chatbot)}}</p>
    <p v-else><span class="mdi mdi-loading mdi-spin"></span></p>
    <p v-if="!isLoading">{{ridatsuten}}番目/<br>ﾒｯｾｰｼﾞ</p>
    <p v-else><span class="mdi mdi-loading mdi-spin"></span></p>
    <p v-if="!isLoading">{{robotojiru}}</p>
    <p v-else><span class="mdi mdi-loading mdi-spin"></span></p>
    <p v-if="!isLoading">{{browsertojiru}}</p>
    <p v-else><span class="mdi mdi-loading mdi-spin"></span></p>
    <p v-if="!isLoading">{{betsurobo}}</p>
    <p v-else><span class="mdi mdi-loading mdi-spin"></span></p>
  </div>
</template>

<script>
export default {
  props: {
    chatbot: {
      type: Object,
      required: true,
    },
    period: {
      type: Object,
      required: false,
    },
  },
  data () {
    return {
      chatbotData: null,
      isLoading: false,
      num: 0
    }
  },
  created () {
    this.loadPerfData(this.chatbot)
  },
  computed: {
    ridatsuten () {
      if (this.num === 0) {
        return '-'
      } else {
        return this.num
      }
    },
    taiosu () {
      return this.chatbotData.taiosu
    },
    kanryosu () {
      return this.chatbotData.kanryosu
    },
    robotojiru () {
      return this.chatbotData.robotojiru
    },
    browsertojiru () {
      return this.chatbotData.browsertojiru
    },
    betsurobo () {
      return this.chatbotData.betsurobo
    },
  },
  watch: {
    period () {
      this.loadPerfData(this.chatbot)
    }
  },
  methods: {
    // 初期読み込み
    loadPerfData (chatbot) {
      this.isLoading = true
      let param = {}
      if (this.period.begin) param.since = this.period.begin.toLocaleString('ja-JP')
      if (this.period.end) param.until = this.period.end.toLocaleString('ja-JP')
      this.$store.dispatch('chatbot/getChatBotPerformance', {id: chatbot.bot_id, param: param})
        .then((data) => {
          this.chatbotData = data
          this.getNumberScenario(this.chatbotData.ridatsuten)
          this.isLoading = false
        })
    },
    botAction (chatbot) {
      let ridatu = (100 - Math.floor(this.kanryosu / this.taiosu * 100))
      ridatu = isNaN(ridatu) ? 0 : ridatu
      return ridatu + '%'
    },
    // 何番目か
    getNumberScenario (id) {
      this.citableScenarios = []
      let matchSomeScenario = {}
      let matchScenarioTable = []
      let someScenario = []
      let count = 0
      this.$store.dispatch('chatbot/getScenarioList', { companyid: this.chatbot.group, scenarioName: this.chatbot.scenario_name })
      .then((d) => {
        let scenarioTable = d.data
        // データが存在しない場合の早期リターン
        if (!scenarioTable || !Array.isArray(scenarioTable)) {
          console.error('シナリオデータが取得できませんでした', d)
          this.num = 0
          return
        }
        // 起点になるシナリオ
        for (let s of scenarioTable) {
          if (s.beforenode === id) {
            matchSomeScenario[id] = s
            if (s.start_flg) {
              // 起点が開始地点なら即終了
              this.num = 1
              return
            }
          }
        }
        // 全シナリオを取得
        for (let s of scenarioTable) {
          matchScenarioTable.push(s)
        }
        // 引用リスト作成処理
        let makeCitableScenariolList = () => {
          count += 1
          someScenario = {}
          // 全シナリオ分判定する
          for (let s of matchScenarioTable) {
            // シナリオが持つnext_node分判定する
            for (let select of s.select) {
              // スタックしたシナリオのbeforenodeと一致するものを探す
              for (let [, match] of Object.entries(matchSomeScenario)) {
                if (select.next_node === match.beforenode) {
                  // next_nodeがスタックしたシナリオのbeforenodeに一致
                  if (s.beforenode !== id) {
                    // 開始位置なら終了
                    if (s.start_flg) {
                      this.num = count
                      return
                    }
                  }
                  // 同じものを追加しないように上書きしていく
                  someScenario[s.beforenode] = s
                }
              }
            }
          }
          // 次に回ってきたときの引用リスト検証シナリオリスト
          matchSomeScenario = someScenario
          // 全シナリオを舐めたら終了
          if (count > matchScenarioTable.length) {
            return
          }
          // 再帰処理
          makeCitableScenariolList()
        }
        makeCitableScenariolList()
      // 終了
      })
      .catch((error) => {
        console.error('シナリオリスト取得エラー:', error)
        this.num = 0
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.data-table {
  display: flex;
  justify-content: space-around;
  align-items: center;
  p {
    width: 64px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Performance/organisms/PerformanceData.vue